import type { ImageEntry } from "../types";

export function Gallery({
  images,
  progress,
  onOpenLevel,
}: {
  images: ImageEntry[];
  progress: number; // solved count
  onOpenLevel: (idx: number) => void;
}) {
  const total = images.length;
  const unlockedIndex = Math.min(progress, total - 1);

  return (
    <div className="gallery-grid">
      {images.map((pair, idx) => {
        const isSolved = idx < progress;
        const isUnlocked = idx === unlockedIndex;
        const isLocked = idx > unlockedIndex;

        return (
          <button
            key={idx}
            className="thumb-wrap"
            onClick={() => !isLocked && onOpenLevel(idx)}
            disabled={isLocked}
            aria-label={
              isLocked ? `Locked picture ${idx + 1}` :
              isSolved ? `Solved picture ${idx + 1}` :
              `Play picture ${idx + 1}`
            }
          >
            <div className="thumb-frame">
              <img
                src={isSolved ? pair.clear : pair.blurred}
                alt={`picture-${idx + 1}`}
                className="thumb-img"
              />
            </div>

            {isLocked && <div className="lock-badge">🔒</div>}
            {isUnlocked && !isSolved && <div className="play-badge">Play</div>}
            {isSolved && <div className="solved-badge">✅</div>}
          </button>
        );
      })}
    </div>
  );
}
